(function ($) {

    function initSlider() {

        if ($(window).width() > 767) return;

        $('.ankur-mobile-slider').each(function () {

            if ($(this).hasClass('slick-initialized')) return;

            $(this).slick({

                slidesToShow:1,

                slidesToScroll:1,

                arrows:false,

                dots:true,

                infinite:true,

                autoplay:true,

                autoplaySpeed:4000,

                speed:600,

                swipe:true,

                touchMove:true,

                draggable:true,

                adaptiveHeight:true,

                pauseOnHover:false,

                pauseOnFocus:false

            });

        });

    }

    $(document).ready(function(){

        initSlider();

    });

})(jQuery);